import React, { useEffect, useState } from "react";

/* StreamElapsed (Wave 3.8) — a self-contained 1 Hz ticking duration label
   ("12s" / "1m 05s"). The interval and its tick state live INSIDE this
   component, so the timer re-renders nothing but this tiny span — not the
   activity timeline, the message row, or the page. When `active` flips
   false the interval stops and the last value freezes (callers unmount it
   then and render their own frozen "Worked for Ns" label). */

export const formatElapsedSeconds = (ms) => {
  const totalSeconds = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
};

const StreamElapsed = ({ startedAt, active = true }) => {
  const [nowTick, setNowTick] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return undefined;
    setNowTick(Date.now());
    const timer = setInterval(() => setNowTick(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [active, startedAt]);

  if (!startedAt) return null;
  const startedAtMs = new Date(startedAt).getTime();
  if (Number.isNaN(startedAtMs)) return null;

  return (
    <span className="facility-ai-stream-elapsed" aria-hidden="true">
      {formatElapsedSeconds(nowTick - startedAtMs)}
    </span>
  );
};

export default StreamElapsed;
